module.exports = __webpack_public_path__ + "img/search_oliver.dc7d51f2.gif";